module.exports = __webpack_public_path__ + "img/Google voice Icon - charcoal.3152994e.svg";